module.exports = __webpack_public_path__ + "static/media/photo247.6d835626.jpg";